import { Order } from '~src/ts/helpers/Order';
import { OrderKeys } from '~src/ts/models/OrderKeys';
import { SortOptions } from '~src/ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/ts/models/sort/SortOptionDefinitions';
import { IOrderClause } from '~src/ts/ServerApi/types/IOrderClause';

export const favoritesSpaceDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.position)];

export const favoritesMixedContentOptions: OptionsDictionary = {
  // Mixed Content does not support relevance
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
  'dateAdded': SortOptions.dateAdded,
  'position': SortOptions.position,
  'containerName': SortOptions.containerName
};
